import RouteLeg from './leg';
import RouteSegment from './segment';

export default class Route {
  legs = [];

  segments = [];

  path = null;

  constructor (legs) {
    const tempSegment = [];

    this.legs = legs.map((leg, index) => {
      const last = typeof leg.last !== 'undefined'
        ? leg.last
        : index === legs.length - 1;
      return new RouteLeg({
        ...leg,
        last,
      });
    });
    this.legs.forEach(leg => {
      tempSegment.push(leg);
      if (leg.isLastInSegment) {
        this.segments.push(new RouteSegment([...tempSegment]));
        tempSegment.length = 0;
      }
    });

    this.path = new RouteSegment([...this.legs]);
  }

  get uid () {
    return this.path.uid;
  }

  get points () {
    return this.path.points;
  }
};
